import { clampWatermarkPosition, type WatermarkPosition } from './watermarkPosition';

/** Horizontal distance (frame fraction) within which the center snaps to 0.5. */
export const WATERMARK_SNAP_THRESHOLD = 0.02;

/** A dragged center → the stored position: snap x to the frame center (unless
 *  bypassed with Ctrl/Cmd), then clamp into the platform safe zone. */
export function mapDragToWatermarkPosition({
  x,
  y,
  frameAspect,
  snap,
}: {
  x: number;
  y: number;
  frameAspect: number;
  snap: boolean;
}): WatermarkPosition {
  const snappedX = snap && Math.abs(x - 0.5) < WATERMARK_SNAP_THRESHOLD ? 0.5 : x;
  return clampWatermarkPosition({ x: snappedX, y }, frameAspect);
}
